/**
 * Strips out BSON ObjectIds and converts them into "?"
 * For example:
 * > groupifyUrl("/engagement/canvas/5e0f98964b895c722f07d327/51804f26dd365acfa700026a")
 * "/engagement/canvas/?/?"
 */
export const groupifyUrl = (url: string) => {
  return url.replace(/[0-9a-f]{24}/g, "?");
};
